import gql from 'graphql-tag';
import { INSPECTION_SCOPE_ITEM_FIELDS } from '../schemas';

export const UPDATE_INSPECTION_SCOPE_ITEM = gql`
  ${INSPECTION_SCOPE_ITEM_FIELDS}

  mutation UpdateInspectionScopeItem(
    $input: UpdateInspectionScopeItemInput! # id, budget, clientDisbursement, disbursement, name, description
  ) {
    updateInspectionScopeItem(input: $input) {
      inspectionScopeItem {
        ...InspectionScopeItemFields
      }
    }
  }
`;
